"use client";

import { getAnalytics } from "@homeinstead/analytics";
import { useEffect, useState } from "react";

export function InvokeInvoca() {
  const [hasRunInvoca, setHasRunInvoca] = useState<boolean>(false);

  // only run on client (or the server will throw errors even if "use client" is used) 🤷‍♂️
  const isClient = typeof window !== "undefined";
  const isReady = isClient && typeof window?.Invoca?.PNAPI?.run === "function";

  // get Segment
  const analytics = getAnalytics({});
  const isAnalyticsReady = !!analytics;

  useEffect(() => {
    // initialize Invoca once and once only!
    // and make sure Segment is ready already
    // (so we're more likely to have the ajs_anonymous_id cookie ready)
    if (isReady && !hasRunInvoca && isAnalyticsReady) {
      console.log("Initializing Invoca.");
      window.Invoca!.PNAPI!.run();
      // TODO stop suppressing this warning (don't replicate this!)
      // eslint-disable-next-line react-hooks/set-state-in-effect
      setHasRunInvoca(true);
    }
  }, [isReady, hasRunInvoca, isAnalyticsReady]);

  return null;
}
